import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { RoadTypeParams } from './service';

export enum RoadTypeActions {
  Failure = '[Catalogs RoadType] Failure',
  Request = '[Catalogs RoadType] Request',
  Success = '[Catalogs RoadType] Success',
}

export const RoadTypeFailure = createAction(RoadTypeActions.Failure, props<{ error: HttpErrorResponse }>());

export const RoadTypeRequest = createAction(RoadTypeActions.Request, props<{ parameters: RoadTypeParams }>());

export const RoadTypeSuccess = createAction(RoadTypeActions.Success, props<{ data: ParameterResult }>());
